"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionItem = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Accordion = function (_a) {
    var children = _a.children;
    var _b = react_1.useState(null), show = _b[0], setShowing = _b[1];
    var toggle = function (i) { return function () { return setShowing(show === i ? null : i); }; };
    var items = react_1.Children.toArray(children);
    var renderItem = function (item, i) { return (react_1.default.createElement("div", { className: 'card', key: i },
        react_1.default.createElement("div", { className: 'card-header', onClick: toggle(i), style: { cursor: 'pointer' } }, item.props.head),
        react_1.default.createElement("div", { className: classnames_1.default('collapse', { show: show === i }) },
            react_1.default.createElement("div", { className: 'card-body' }, item)))); };
    return react_1.default.createElement("div", { className: 'accordion' }, items.map(renderItem));
};
var AccordionItem = function (_a) {
    var head = _a.head, children = _a.children;
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.AccordionItem = AccordionItem;
exports.default = Accordion;
//# sourceMappingURL=Accordion.js.map